import React from 'react';
import { Form, Col, Row, Button, Spinner } from 'react-bootstrap'
import { Link } from "react-router-dom";
import axios, { AxiosRequestConfig } from 'axios';
import PropTypes from 'prop-types';
import { Constants } from "../../constants";
import { MultiSelect } from "react-multi-select-component";
import SiteMenu from "../menu";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../App.css';
import ContractDetailsCard from './orders_contract_details_card';
import ServiceDetailsCard from './orders_service_details_card';
import JobCostDetailsCard from './orders_jobcost_details_card';
import PartsDetailsCard from './orders_parts_details_card';
import ReactGA from "react-ga4";


class OpenOrders extends React.Component {

    constructor(props) {
        super(props);
        console.log(props);

        let userExists = !(props.location.state == null || props.location.state.user == null);
        let historyExists = !(props.history.location.state == null || props.history.location.state.accounts == null || props.history.location.state.accounts.length == 0);
        console.log(historyExists);
        if (!historyExists) {
            this.state = {
                user: userExists ? props.location.state.user : {},
                page: 1,
                contractData: [],
                serviceData: [],
                partsData: [],
                accounts: [],
                selectedAccounts: [],
                accountSearchString: '',
                contractPage: 1,
                servicePage: 1,
                partsPage: 1,
                totalSize: 0,
                sizePerPage: 20,
                searchTerm: '',
                contractLoading: true,
                serviceLoading: true,
                partsLoading: true
            };
        }
        else {
            this.state = props.history.location.state;
        }
        /*this.handleTableChange = this.handleTableChange.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);

        this.filterStatus = React.createRef();
        this.filterType = React.createRef();
        this.filterText = React.createRef();*/

        this.searchBox = React.createRef();

        this.createContractCards = this.createContractCards.bind(this);
        this.createServiceCards = this.createServiceCards.bind(this);
        this.getAllData = this.getAllData.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.getAccounts = this.getAccounts.bind(this);
        this.selectAccounts = this.selectAccounts.bind(this);

        this.getServiceData = this.getServiceData.bind(this);
        this.handlePaging = this.handlePaging.bind(this);
    }

    getAccounts() {


        this.props.history.replace({
            ...this.props.history.location,
            state: this.state
        });
        axios.get(`${Constants.apiURL}/api/Payment/accounts`, {
            params: {
                username: this.state.user.username,
                isWork: true
            }
        }).then(response => {
            if (response.data) {
                console.log(response.data);
                let accounts = response.data.map(function (acc) {
                    return {
                        label: acc.accountID + " | " + acc.accountName,
                        value: acc.accountID
                    };
                });

                this.setState(() => ({
                    accounts: accounts
                }));
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    selectAccounts(selected) {
        let selectedAccountsString = selected.map((item) => {
            return item.value
        }).join(',');
        this.setState({
            selectedAccounts: selected,
            accountSearchString:selectedAccountsString
        }, this.getAllData);
    }

    componentDidMount() {
        this.getAllData();
    }

    getAllData() {

        this.setState({
            contractLoading: true,
            serviceLoading: true,
            partsLoading: true
        });
        ReactGA.event({
            category: 'Search',
            action: 'Open Orders',
            label: 'Open Orders Search'
        });

        axios.get(`${Constants.apiURL}/api/Order/GetOpenOrdersFull`, {
            params: {
                user: this.state.user.username,
                searchTerm: this.state.searchTerm.trim(),
                accountSearchString: this.state.accountSearchString.trim()
            }
        }).then(response => {
            if (response.data) {
                let x = JSON.parse(response.data.serviceData);
                let y = JSON.parse(response.data.contractData);
                let z = JSON.parse(response.data.partsData);
                this.setState(() => ({
                    serviceData: x,
                    contractData: y,
                    partsData: z,
                    contractPage: 1,
                    servicePage: 1,
                    partsPage: 1,
                    contractLoading: false,
                    serviceLoading: false,
                    partsLoading: false
                }), this.getAccounts);
            }
        }).catch((response) => {
            if (response.response.status === 401) {
                this.props.history.push({
                    pathname: '/'
                });
            }
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({
                contractLoading: false,
                serviceLoading: false,
                partsLoading: false
            });
            console.log('request failed', response)
        });
    }

    getPartsData(page) {
        this.setState({ partsLoading: true });
        axios.get(`${Constants.apiURL}/api/Order/GetPartsOrders`, {
            params: {
                user: this.state.user.username,
                page: page,
                searchTerm: this.state.searchTerm,
                accountSearchString: this.state.accountSearchString
            }
        }).then(response => {
            if (response.data) {
                let x = JSON.parse(response.data.data);
                this.setState(() => ({
                    partsData: x,
                    partsPage: page,
                    partsLoading: false
                }));

            }
        }).catch((response) => {
            if (response.response.status === 401) {
                this.props.history.push({
                    pathname: '/'
                });
            }
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ partsLoading: false });
            console.log('request failed', response)
        });
    }

    getContractData(page) {
        this.setState({ contractLoading: true });
        axios.get(`${Constants.apiURL}/api/Order/GetContractOrders`, {
            params: {
                user: this.state.user.username,
                page: page,
                searchTerm: this.state.searchTerm,
                accountSearchString: this.state.accountSearchString
            }
        }).then(response => {
            if (response.data) {
                let x = JSON.parse(response.data.data);
                this.setState(() => ({
                    contractData: x,
                    contractPage: page,
                    contractLoading: false
                }));
            }
        }).catch((response) => {
            if (response.response.status === 401) {
                this.props.history.push({
                    pathname: '/'
                });
            }
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ contractLoading: false });
            console.log('request failed', response)
        });
    }

    getServiceData(page) {
        this.setState({ serviceLoading: true });
        axios.get(`${Constants.apiURL}/api/Order/GetServiceOrders`, {
            params: {
                user: this.state.user.username,
                page: page,
                searchTerm: this.state.searchTerm,
                accountSearchString: this.state.accountSearchString
            }
        }).then(response => {
            if (response.data) {
                let x = JSON.parse(response.data.data);
                this.setState(() => ({
                    serviceData: x,
                    servicePage: page,
                    serviceLoading: false
                }));
            }
        }).catch((response) => {
            if (response.response.status === 401) {
                this.props.history.push({
                    pathname: '/'
                });
            }
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ serviceLoading: false });
            console.log('request failed', response)
        });
    }

    createPartsCards() {
        let items = [];
        if (this.state.partsData.length == 0) {
            return <div class="row-gray" style={{ width: '100%' }}> <Form.Label style={{ paddingTop: '10px' }}>No open parts orders</Form.Label></div>
        }
        items = this.state.partsData.map(function (item, index) {
            var className = (index % 2 == 0) ? "row-white" : "row-gray";
            return <PartsDetailsCard user={this.state.user} id={item.OrderKey} key={item.OrderKey} data={item} class={className} />;
        }.bind(this));
        return items;
    }

    createContractCards() {
        let items = [];
        if (this.state.contractData.length == 0) {
            return <div class="row-gray" style={{ width: '100%' }}> <Form.Label style={{ paddingTop: '10px' }}>No open contracts</Form.Label></div>
        }
        items = this.state.contractData.map(function (item, index) {
            var className = (index % 2 == 0) ? "row-white" : "row-gray";
            return <ContractDetailsCard user={this.state.user} id={item.OrderKey} key={item.OrderKey} data={item} class={className} />;
        }.bind(this));
        return items;
    }

    createServiceCards() {
        let items = [];
        if (this.state.serviceData.length == 0) {
            return <div class="row-gray" style={{ width: '100%' }}> <Form.Label style={{ paddingTop: '10px' }}>No open service orders</Form.Label></div>
        }
        items = this.state.serviceData.map(function (item, index) {
            var className = (index % 2 == 0) ? "row-white" : "row-gray";
            if (item.SubType == "ServiceCall") {
                return <ServiceDetailsCard user={this.state.user} id={item.OrderKey} key={item.OrderKey} data={item} class={className} />;
            }
            else {
                return <JobCostDetailsCard user={this.state.user} id={item.OrderKey} key={item.OrderKey} data={item} class={className} />;
            }
        }.bind(this));
        return items;
    }

    handleClear(event) {
        event.preventDefault();
        this.searchBox.current.value = "";
        //this.filterType.current.value = "";
        //this.filterText.current.value = "";

        this.setState({
            searchTerm: '',
            selectedAccounts: [],
            accountSearchString: ''
        }, function () {
            this.getAllData();
        });

    }

    handlePaging(event) {
        console.log(event);
        if (event.target.name == "serviceNext") {
            this.getServiceData(this.state.servicePage + 1);
        }
        else if (event.target.name == "servicePrevious") {
            this.getServiceData(this.state.servicePage - 1);
        }
        else if (event.target.name == "partsNext") {
            this.getPartsData(this.state.partsPage + 1);
        }
        else if (event.target.name == "partsPrevious") {
            this.getPartsData(this.state.partsPage - 1);
        }
        else if (event.target.name == "contractNext") {
            this.getContractData(this.state.contractPage + 1);
        }
        else if (event.target.name == "contractPrevious") {
            this.getContractData(this.state.contractPage - 1);
        }
    }

    handleSearch(event) {
        event.preventDefault();
        this.getAllData();
    }

    handleSearchChange(event) {
        this.setState({
            searchTerm: event.target.value
        });
    }

    render() {
        const { accounts, selectedAccounts } = this.state;
        const customValueRenderer = (selected, _options) => {
            return selected.length
                ? selected.map(({ label }) => label + ", ").join('').replace(/, $/, '')
                : "Filter by account";
        };
        return (
            <div>
                <SiteMenu user={this.state.user} currentPage='openOrdersPage' />
                <div style={{ margin: 5 }}>
                    <Form onSubmit={this.handleSearch} style={{ marginBottom: 5, display: 'flex', flexDirection: 'row' }} className="open-orders-search">
                        <Form.Label className="mobile-m-l-10" style={{ paddingBottom: 0, marginBottom: 0, paddingLeft: 0, verticalAlign: 'middle', fontWeight: 'bold', fontSize: '21px', color: '#1F419B', width: 'auto' }}>OPEN ORDERS</Form.Label>
                        <MultiSelect
                            options={accounts}
                            onChange={this.selectAccounts}
                            labelledBy="Select"
                            value={selectedAccounts}
                            valueRenderer={customValueRenderer}
                            hasSelectAll={false}
                          />
                        <Form.Control className="mobile-m-t-10 mobile-m-l-10" style={{ width: '340px' }} type="input" size="sm" ref={this.searchBox} value={this.state.searchTerm} onChange={this.handleSearchChange} placeholder="Search by order number, building, description..." />
                        <Button className="mobile-m-t-10 mobile-m-l-10" size="sm" style={{ width: 'auto', marginRight: 5, marginLeft: 5, backgroundColor: '#1F419B' }} type="submit" >Search</Button>
                        <Button className="mobile-m-t-10 mobile-m-l-10" size="sm" style={{ width: 'auto', marginLeft: 0 }} variant="secondary" onClick={this.handleClear}>Clear</Button>
                    </Form>
                    <Row>
                        <Col md={6} style={{ paddingRight: 10 }}>
                            <div style={{
                                backgroundColor: '#696B73', padding: 5, borderRadius: '5px', display: 'flex', flexDirection: 'row'
                            }}>
                                <Form.Label style={{ marginBottom: 0, fontWeight: 'bold', color: 'white', fontSize: 20, verticalAlign: 'middle' }}>Contracts</Form.Label>
                                <Button as={Link} to={{
                                    pathname: "/consultation_request",
                                    state: {
                                        user: this.state.user,
                                        typeofrequest: "Service Contract"
                                    }
                                }} size="sm" style={{ width: 'auto', backgroundColor: '#EF4139', marginLeft: 'auto' }} >Contract Consulation</Button>
                            </div>
                            <div style={{ display: 'flex', position: 'relative', justifyContent: 'center', marginTop: 5 }} hidden={!this.state.contractLoading}>
                                <Spinner animation="border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner>
                            </div>
                            <div hidden={this.state.contractLoading}>
                                {this.createContractCards()}
                            </div>
                            <div style={{ display: 'flex' }}>
                                <Button name="contractPrevious" size="sm" disabled={this.state.contractPage == 1} style={{ width: '50px', marginLeft: 'auto' }} onClick={this.handlePaging} >&lt;&lt;</Button>
                                <Button name="contractNext" size="sm" disabled={this.state.contractData.length < 4} style={{ width: '50px', marginLeft: 5 }} onClick={this.handlePaging} >&gt;&gt;</Button>
                            </div>
                            <div style={{ backgroundColor: '#696B73', padding: 5, marginTop: 15, borderRadius: '5px', display: 'flex', flexDirection: 'row' }}>
                                <Form.Label style={{ marginBottom: 0, fontWeight: 'bold', color: 'white', fontSize: 20, verticalAlign: 'middle' }}>Parts & Supplies</Form.Label>
                                <Button as={Link} to={{
                                    pathname: "/parts_request",
                                    state: {
                                        user: this.state.user
                                    }
                                }} size="sm" style={{ width: 'auto', backgroundColor: '#EF4139', marginLeft: 'auto' }} >Order Parts & Supplies</Button>
                            </div>
                            <div style={{ display: 'flex', position: 'relative', justifyContent: 'center', marginTop: 5 }} hidden={!this.state.partsLoading}>
                                <Spinner animation="border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner>
                            </div>
                            <div hidden={this.state.partsLoading}>
                                {this.createPartsCards()}
                            </div>
                            <div style={{ display: 'flex' }}>
                                <Button name="partsPrevious" size="sm" disabled={this.state.partsPage == 1} style={{ width: '50px', marginLeft: 'auto' }} onClick={this.handlePaging}>&lt;&lt;</Button>
                                <Button name="partsNext" size="sm" disabled={this.state.partsData.length < 4} style={{ width: '50px', marginLeft: 5 }} onClick={this.handlePaging} >&gt;&gt;</Button>
                            </div>
                        </Col>
                        <Col md={6} style={{ paddingRight: 10 }}>
                            <div style={{ backgroundColor: '#696B73', padding: 5, borderRadius: '5px', display: 'flex', flexDirection: 'row' }}>
                                <Form.Label style={{ marginBottom: 0, fontWeight: 'bold', color: 'white', fontSize: 20, verticalAlign: 'middle' }}>Service</Form.Label>
                                <Button as={Link} to={{
                                    pathname: "/service_request",
                                    state: {
                                        user: this.state.user
                                    }
                                }} size="sm" style={{ width: 'auto', backgroundColor: '#EF4139', marginLeft: 'auto' }} >Request Service</Button>
                            </div>
                            <div style={{ display: 'flex', position: 'relative', justifyContent: 'center', marginTop: 5 }} hidden={!this.state.serviceLoading}>
                                <Spinner animation="border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner>
                            </div>
                            <div ref={this.serviceCardDiv} hidden={this.state.serviceLoading}>
                                {this.createServiceCards()}
                            </div>
                            <div style={{ display: 'flex' }}>
                                <Button name="servicePrevious" size="sm" disabled={this.state.servicePage == 1} style={{ width: '50px', marginLeft: 'auto' }} onClick={this.handlePaging}>&lt;&lt;</Button>
                                <Button name="serviceNext" size="sm" disabled={this.state.serviceData.length < 8} style={{ width: '50px', marginLeft: 5 }} onClick={this.handlePaging}>&gt;&gt;</Button>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div >
        );
    }
}

export default OpenOrders;